import apiClient from '../utils/axios-config';
import { Outfit, NarrationResponse } from '../types';
import { NarratorVoice } from '../types/fashion-show';
import { logger } from '../utils/logger';

class FashionShowService {
  /**
   * Generate AI voice narration for an outfit.
   * Sends outfit metadata to the backend which generates a stylist commentary
   * and synthesizes speech audio via Amazon Polly.
   */
  async generateNarration(outfit: Outfit, voice: NarratorVoice = 'male'): Promise<NarrationResponse> {
    try {
      const requestBody = {
        outfitId: outfit.id,
        eventType: outfit.eventType,
        description: outfit.description,
        voiceGender: voice,
        clothingItems: (outfit.clothingItems || []).map((item) => ({
          type: item.type || '',
          brand: item.brand || '',
          color: item.color || '',
          description: item.description || '',
        })),
        aiAnalysis: outfit.aiAnalysis
          ? {
              description: outfit.aiAnalysis.description,
              highlights: outfit.aiAnalysis.highlights || [],
              suggestedTags: outfit.aiAnalysis.suggestedTags || [],
            }
          : undefined,
      };

      console.log(`[FashionShowService] Generating narration for outfit ${outfit.id}`);

      const response = await apiClient.post('/fashion-show/narration', requestBody);

      const data = response.data?.data || response.data;

      return {
        audioBase64: data.audioBase64,
        contentType: data.contentType,
        descriptionText: data.descriptionText,
        durationMs: data.durationMs,
      };
    } catch (error: any) {
      console.error(`[FashionShowService] Narration generation failed for outfit ${outfit.id}:`, error);
      logger.apiError('generating fashion show narration', error);
      throw error;
    }
  }
}

export default new FashionShowService();
